import { Navigate } from 'react-router-dom';
import useAuthStore from '../stores/authStore';

const ProtectedRoute = ({ children, requiredRole = 'viewer', requiredPermission = null }) => {
  const { isAuthenticated, isLoading, hasRole, user } = useAuthStore();

  if (isLoading) {
    return (
      <div className="loading-screen">
        <div className="loading-spinner" />
        <p>Loading...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Check role
  if (!hasRole(requiredRole)) {
    return (
      <div className="page-container">
        <div className="card">
          <div className="empty-state">
            <h3>Access Denied</h3>
            <p>You don't have permission to view this page.</p>
          </div>
        </div>
      </div>
    );
  }

  // Check specific permission if required
  if (requiredPermission && !user?.[requiredPermission] && !user?.isPlatformAdmin) {
    return (
      <div className="page-container">
        <div className="card">
          <div className="empty-state">
            <h3>Access Denied</h3>
            <p>You don't have the required permission to view this page.</p>
          </div>
        </div>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
